module.exports = __webpack_public_path__ + "img/44.1e9e656c.png";